import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  const headlines = ["Cómo apagar el 'ruido' mental en 7 minutos sin dejar de ser productivo.", 'El fin de la neblina mental: Recupera tu enfoque de las 9 AM a las 5 PM.', 'No necesitas vacaciones. Necesitas este sistema de reseteo de 7 minutos.', 'Por qué el café ya no te hace efecto (y cómo arreglarlo hoy mismo).', "El método 'Cortisol Off': De la ansiedad al flujo de trabajo en 3 pasos.", 'Tu negocio te necesita lúcido, no exhausto.', 'Hackea tu sistema nervioso para dominar tu mercado.', 'Baja tus pulsaciones, sube tu facturación.'];
  return <Section background="sage" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal-dark mb-4" data-id="element-4">
            Lo que descubrirás dentro
          </h2>
          <p className="text-lg text-brand-charcoal/70" data-id="element-5">
            Estrategias probadas para recuperar el control de tu biología.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-6">
          {headlines.map((headline, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white p-6 rounded-lg shadow-sm border border-brand-sage/20 flex items-start gap-4" data-id="element-7">
              <CheckCircle2 className="h-6 w-6 text-brand-sage flex-shrink-0 mt-1" data-id="element-8" />
              <p className="font-medium text-brand-charcoal-dark leading-snug" data-id="element-9">
                {headline}
              </p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}